import { getConfig } from '../AppConfig';
import { isConsumerApp } from './Helpers';

const finite = (value) => typeof value === 'number' && Number.isFinite(value);
const windowsValid = (days, startKey, endKey) =>
  Array.isArray(days) &&
  days.length === 7 &&
  days.every(
    (windows) =>
      Array.isArray(windows) &&
      windows.every(
        (window) =>
          finite(window?.[startKey]) &&
          finite(window?.[endKey]) &&
          window[startKey] >= 0 &&
          window[endKey] > window[startKey]
      )
  );

// The generator computes both fulfillment modes, even when only one is shown.
export default function timePickerReadiness({
  details,
  generic,
  mode,
  failed,
  loaded,
}) {
  if (!['delivery', 'takeout'].includes(mode)) return 'configuration';
  if (!generic && failed) return 'request';
  if (!generic && !details?.schedules) return loaded ? 'schedule' : 'loading';
  if (!generic) {
    const schedule = details.schedules[mode];
    if (
      !windowsValid(
        Array.isArray(schedule) ? schedule.map((day) => day?.openings) : null,
        'open',
        'close'
      )
    )
      return 'schedule';
  }
  if (isConsumerApp()) {
    const setup = getConfig()?.consumerSetup;
    if (
      !['delivery', 'takeout'].every(
        (type) =>
          finite(setup?.intervals?.[type]) &&
          setup.intervals[type] > 0 &&
          finite(setup?.delays?.[type]) &&
          setup.delays[type] >= 0 &&
          (!generic || windowsValid(setup?.windows?.[type], 'start', 'end'))
      )
    )
      return 'configuration';
  }
  return 'ready';
}
